import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { SiteConfigurationTemplate, TagMapping } from '../../../types';
import { StatusChip } from '../StatusChip';
import { EmptySection } from '../EmptySection';
import { useTagMappingStatus } from 'src/features/sites/hooks';

type WidgetsSectionProps = {
  template: SiteConfigurationTemplate;
  tagMapping: TagMapping;
};

export const WidgetsSection = ({ template, tagMapping }: WidgetsSectionProps) => {
  const { isBlockingUnmapped, unmappedNames } = useTagMappingStatus(template, tagMapping);

  const rows = template.widgets;
  if (!rows.length) return <EmptySection label="Widgets" />;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Widget Type</TableCell>
            <TableCell>Sub Type</TableCell>
            <TableCell>Note</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((widget) => {
            const alwaysIncluded =
              widget.widgetType === 'LIFT_STATION' || widget.widgetType === 'ASSET_CONTROLLER';
            const tagIds = (widget.tags ?? []).map((t) => t.tagIdempotencyKey);
            // Excluded only when ALL tags are unmapped — a widget with at least one mapped
            // tag is still useful. Always-included types are never excluded.
            const included =
              alwaysIncluded || !tagIds.length || !tagIds.every((id) => isBlockingUnmapped(id));
            const missing = unmappedNames(tagIds);

            return (
              <TableRow key={widget.id}>
                <TableCell>{widget.widgetType || '—'}</TableCell>
                <TableCell>{widget.widgetSubType || '—'}</TableCell>
                <TableCell>
                  {!included && missing.length ? (
                    <Typography variant="caption" color="warning.main">
                      Unmapped: {missing.join(', ')}
                    </Typography>
                  ) : null}
                </TableCell>
                <TableCell align="right">
                  <StatusChip included={included} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
